import { useLayoutEffect, useRef, CSSProperties } from "react";

import {
  CAM_VIEW_DESKTOP_CONTAINER,
  CONTAINER_CLASS,
  AUDIO_TEST_DISCONNECTED,
  AUDIO_TEST_VIEW,
  CAM_MOBILE_TOP_SECTION,
} from "../../shared/styleConstants";

import { ViewBoxSize } from "./MainLayout.types";

interface MainLayoutStyles {
  container: CSSProperties;
}

export const useMainLayoutStyles: () => MainLayoutStyles = () => {
  const responsiveScreenHeight = useRef<number>(window.innerHeight);
  const resizeWindow = () => {
    const winHeight = window.document.documentElement.clientHeight;
    const mainElements = document.getElementsByClassName(CONTAINER_CLASS);
    if (mainElements.length) {
      for (let i = 0; i < mainElements.length; i++) {
        const element = mainElements[i] as HTMLElement;
        element.style.minHeight = winHeight + "px";
      }
    }
    const audioTestElement = document.getElementById(AUDIO_TEST_VIEW);
    if (audioTestElement) {
      audioTestElement.style.height =
        winHeight > ViewBoxSize.AudioTestActive ? winHeight + "px" : "480px";
      audioTestElement.style.padding = "20px";
    }

    const audioTestDisconnected = document.getElementById(
      AUDIO_TEST_DISCONNECTED
    );
    if (audioTestDisconnected) {
      audioTestDisconnected.style.height =
        winHeight > ViewBoxSize.AudioTestDisconnected
          ? winHeight + "px"
          : "auto";
      audioTestDisconnected.style.padding = "20px";
    }

    const camDesktopElement = document.getElementById(
      CAM_VIEW_DESKTOP_CONTAINER
    );
    if (camDesktopElement) {
      camDesktopElement.style.height =
        winHeight > ViewBoxSize.CamDesktop ? winHeight + "px" : "auto";
    }

    const camMobileTopElement = document.getElementById(CAM_MOBILE_TOP_SECTION);
    if (camMobileTopElement) {
      camMobileTopElement.style.height =
        winHeight < ViewBoxSize.CamMobile ? "auto" : winHeight - 40 + "px";
    }
  };

  useLayoutEffect(() => {
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);

  return {
    container: {
      minHeight: responsiveScreenHeight.current + "px",
      height: "100%",
    },
  };
};
